/**
 * Portal Manta · LotePage
 * Stub wrapper sobre ContextoLotePage — substitui referência morta no CapaPage.jsx.
 * Fix v29.4: aceita loteKey (string) OU lote (objeto parcial/completo).
 * Sempre resolve o lote completo de DADOS antes de passar para ContextoLotePage,
 * evitando crash quando LOTES_INFO (array) é indexado por string ('3','4','5').
 */
import React from 'react';
import { ContextoLotePage } from './ContextoLotePage.jsx';
import { DADOS } from '../../data/lotes-pr.js';

export const LotePage = ({ lote, loteKey }) => {
  // Resolve a chave: aceita prop loteKey explícita OU lote.k (se lote veio com .k)
  const key = loteKey || lote?.k;
  // Busca lote completo (com tipologias, dados_manta, etc.) em DADOS
  const loteCompleto = (key && DADOS[key]) ? DADOS[key] : lote;
  if (!loteCompleto) return null;
  return <ContextoLotePage lote={loteCompleto} />;
};

export default LotePage;
